import React from 'react';
import './Loader.css';

export default function Loader({ text = "Loading ChatIQ..." }) {
    return (
        <div className="loader-container">
            <div className="loader-spinner"></div>
            <div className="loader-text">{text}</div>
        </div>
    );
}
